/**
 * Линкът от писмо за вход — покана за портала или забравена парола. GoTrue го
 * връща на `/auth/set-password` с данните в hash-а: `type=invite|recovery` при
 * успех, `error=…` при изтекъл или вече използван линк.
 */
export type AuthLinkKind = 'invite' | 'recovery';

export interface AuthLink {
  kind: AuthLinkKind | null;
  failed: boolean;
}

export type SetPasswordView = AuthLinkKind | 'invalid';

export function readAuthLink(hash: string): AuthLink {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const type = params.get('type');
  return {
    kind: type === 'invite' || type === 'recovery' ? type : null,
    failed: params.has('error') || params.has('error_code'),
  };
}

/**
 * Какво показва екранът за задаване на парола. Паролата се задава само през
 * линк от писмо, който е донесъл сесия: без сесия няма на кого да се зададе;
 * провален линк или влязъл потребител без линк не получават форма, за да не
 * сменим тихо паролата на друг влязъл човек.
 */
export function setPasswordView(hasSession: boolean, link: AuthLink): SetPasswordView {
  if (link.failed || !hasSession || !link.kind) return 'invalid';
  return link.kind;
}

/**
 * Потвърждава линка срещу сесията, с която е завършила инициализацията.
 * `type=` в hash-а е само твърдение: ако токенът от линка е невалиден,
 * supabase-js запазва заварената сесия — и формата би сменила паролата на
 * вече влезлия човек. Линкът важи само ако сесията е точно тази, която той е
 * донесъл.
 */
export function confirmAuthLink(link: AuthLink, hash: string, sessionAccessToken: string | null): AuthLink {
  if (!link.kind) return link;
  const linkToken = new URLSearchParams(hash.replace(/^#/, '')).get('access_token');
  if (!linkToken || linkToken !== sessionAccessToken) return { kind: null, failed: true };
  return link;
}
